import { Container } from './styles'

export const FormLayout: React.FC = ({ children }) => (
  <Container>{children}</Container>
)

export default FormLayout
